var _defs, _path, _line, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1100({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.5px;}.b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8,8a7,7,0,0,0-7,7H15A7,7,0,0,0,8,8Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 0.57,
    y1: 2.14,
    x2: 4.5,
    y2: 8.94
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.12,6.41H5.68V3.61a2.56,2.56,0,0,1-.41.31,3.09,3.09,0,0,1-.46.22V3.72a3,3,0,0,0,.64-.42,2,2,0,0,0,.39-.48h.28Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.25,5.48l.46,0a.77.77,0,0,0,.24.5.6.6,0,0,0,.45.17.71.71,0,0,0,.54-.24.93.93,0,0,0,.22-.63.81.81,0,0,0-.22-.59.71.71,0,0,0-.55-.22A.79.79,0,0,0,8,4.52a.73.73,0,0,0-.27.25l-.41,0,.34-1.84H9.45V3.3H8l-.2,1A1.25,1.25,0,0,1,8.51,4a1.1,1.1,0,0,1,.79.32,1.17,1.17,0,0,1,.32.84A1.31,1.31,0,0,1,9.34,6a1.13,1.13,0,0,1-.94.43,1.17,1.17,0,0,1-.8-.27A1.08,1.08,0,0,1,7.25,5.48Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.81,6.41l1.38-3.58h.51l1.46,3.58h-.54l-.41-1.08h-1.5l-.39,1.08Zm1-1.47h1.21l-.37-1c-.12-.3-.2-.55-.26-.74a4,4,0,0,1-.19.68Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1100);
export default __webpack_public_path__ + "static/media/Symbolpack_1_100.be22e953ae965510dc9597c875406afb.svg";
export { ForwardRef as ReactComponent };